import { FetchHandler, GristData } from './types.js'

export interface DataConsumer extends EventTarget {
  data: any
  _data: GristData
  mode: 'GRID' | 'LIST' | 'CARD' | 'REPORT'
  checkDirties(): void
  fetchHandler?: FetchHandler
  showSpinner(): void
  hideSpinner(): void
}
